
import { useState } from 'react';
import { Link } from "react-router-dom"

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMenuOpen(false);
  };

  return (
    <header className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-sm shadow-sm z-50">
      <nav className="container mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-gradient-to-r from-pink-400 to-teal-400 rounded-full flex items-center justify-center">
              <i className="ri-palette-line text-white text-xl"></i>
            </div>
            <Link
  to="/"
  className="text-xl font-bold bg-gradient-to-r from-pink-500 to-teal-500 bg-clip-text text-transparent"
  style={{ fontFamily: 'Pacifico, serif' }}
>
  Ms Plantage
</Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('home')}
              className="text-gray-700 hover:text-pink-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              ホーム
            </button>
            <button 
              onClick={() => scrollToSection('services')}
              className="text-gray-700 hover:text-pink-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              サービス
            </button>
            <button 
              onClick={() => scrollToSection('gallery')}
              className="text-gray-700 hover:text-pink-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              ギャラリー
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className="text-gray-700 hover:text-pink-500 transition-colors cursor-pointer whitespace-nowrap"
            >
              会社概要
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className="bg-gradient-to-r from-pink-500 to-teal-500 text-white px-6 py-2 rounded-full hover:shadow-lg transition-all cursor-pointer whitespace-nowrap"
            >
              お問い合わせ
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden w-8 h-8 flex items-center justify-center cursor-pointer"
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-2xl text-gray-700`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden mt-4 py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <button 
                onClick={() => scrollToSection('home')}
                className="text-gray-700 hover:text-pink-500 transition-colors text-left cursor-pointer"
              >
                ホーム
              </button>
              <button 
                onClick={() => scrollToSection('services')}
                className="text-gray-700 hover:text-pink-500 transition-colors text-left cursor-pointer"
              >
                サービス
              </button>
              <button 
                onClick={() => scrollToSection('gallery')}
                className="text-gray-700 hover:text-pink-500 transition-colors text-left cursor-pointer"
              >
                ギャラリー
              </button>
              <button 
                onClick={() => scrollToSection('about')}
                className="text-gray-700 hover:text-pink-500 transition-colors text-left cursor-pointer"
              >
                会社概要
              </button>
              <button 
                onClick={() => scrollToSection('contact')}
                className="bg-gradient-to-r from-pink-500 to-teal-500 text-white px-6 py-2 rounded-full hover:shadow-lg transition-all text-left cursor-pointer whitespace-nowrap"
              >
                お問い合わせ
              </button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
